import createCtx from 'coreUtils/createCtx';
import {IAccordionContext} from '../IAccordionGroup';

export const [useAccordionGroup, AccordionGroupContext] = createCtx<IAccordionContext>();
